import { ContentItemActionType } from '../../api/types';


export const ACTION_TYPE_TO_TRANSLATION_KEY_MAP: Record<ContentItemActionType, string> = {
  [ContentItemActionType.Cut]: 'wiki.trainings-list.cut',
  [ContentItemActionType.Make]: 'wiki.trainings-list.make',
};
